<mat-form-field>
  <mat-label>{{ 'field' | translate }}</mat-label>

  <input type="search" #searchInput matInput [formControl]="fieldControl" [matAutocomplete]="auto" (focus)="onInputFocus()">

  <mat-autocomplete #auto="matAutocomplete" panelWidth="auto" autoActiveFirstOption
    [displayWith]="displayFn"
    (closed)="onInputBlur()"
    (optionSelected)="onOptionSelected($event.option.value)">

    <mat-option *ngFor="let value of filteredValues | async" [value]="value">
      {{ availableValues.get(value) | translate }}
    </mat-option>
    <mat-option *ngIf="(filteredValues | async)?.length === 0" disabled>
      {{ 'noResults' | translate }}
    </mat-option>

  </mat-autocomplete>
</mat-form-field>